import { PrismicRichText } from '@prismicio/react'
import { QuoteContainer, QuoteText, QuoteAttribution, QuoteImage } from './quote_styles.js'

const Quote = props =>
  <QuoteContainer {...props}>
    <QuoteImage src={props.image} alt='' />
    <PrismicRichText
      field={props.quote?.richText}
      components={{
        paragraph: ({ children }) => <QuoteText>{children}</QuoteText>
      }}
    />
    <QuoteAttribution variant='h5'>{`– ${props.attribution}`}</QuoteAttribution>
  </QuoteContainer>

export default Quote
